/**
 * Top-bar control that flips ledger/order tables between Comfortable and
 * Compact row density. The heavy lifting is CSS-only (see App.css +
 * lib/density.js); this button just flips the preference and reflects state.
 */
import React from 'react';
import { Rows3, Rows4 } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useDensity } from '@/lib/density';

export function DensityToggle() {
  const { density, isCompact, toggleDensity } = useDensity();
  const currentLabel = isCompact ? 'Compact rows' : 'Comfortable rows';
  const nextLabel = isCompact ? 'Comfortable' : 'Compact';

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={toggleDensity}
            aria-label={`Table density: ${currentLabel}. Switch to ${nextLabel}.`}
            aria-pressed={isCompact}
            data-testid="table-density-toggle"
            data-density-state={density}
            className="inline-flex items-center justify-center h-9 w-9 rounded-md hover:bg-slate-100 text-slate-600 transition-colors duration-150"
          >
            {isCompact ? <Rows4 size={18} /> : <Rows3 size={18} />}
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom" data-testid="table-density-tooltip">
          <span className="text-xs">
            {currentLabel} · click for {nextLabel}
          </span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default DensityToggle;
